import { useLocation } from "react-router-dom";

// Helper function that converts a React Router location
// into a standard URL object so we can get host, href, etc.
export function getURLAttributes(location: ReturnType<typeof useLocation>): {
  url: string;
  path: string;
  host: string;
  query: string;
} {
  // Use window.location.origin to build a fully qualified URL
  const baseUrl = window.location.origin;
  const fullUrl = new URL(location.pathname + location.search, baseUrl);

  return {
    url: fullUrl.href,
    path: fullUrl.pathname,
    host: fullUrl.host,
    query: fullUrl.search,
  };
}
